import '../DeepAnalysis.less';
import React from 'react';
import { URL_HIGH_SCORE_THRESHOLD, URL_MEDIUM_SCORE_THRESHOLD } from '../settings';


const sizes = {
    small: '12px',
    medium: '14px',
    big: '16px',
};

const colors = {
    red: '#D43232',
    orange: '#D79A24',
    green: '#18A655',
};

type Props = {
    value: number;
    showDecimals?: boolean;
    size?: keyof typeof sizes;
};


export default function ScoreIndicator({ value, showDecimals, size }: Props) {
    let color;

    if (value < URL_MEDIUM_SCORE_THRESHOLD) {
        color = colors['red'];
    } else if (value < URL_HIGH_SCORE_THRESHOLD) {
        color = colors['orange'];
    } else {
        color = colors['green'];
    }

    return (
        <div className="deep-analysis-generic-check">
            <span
                className="score-coloured-circle"
                style={{
                    width: `${sizes[size || 'medium']}`,
                    height: `${sizes[size || 'medium']}`,
                    borderColor: `${color}`,
                }}
            />
            {showDecimals ? value.toFixed(2) : value}/100
        </div>
    );
}
